import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import { Theme } from "@mui/material/styles";
import { DemandAdjustment } from "../../types/demand-factor.type";
import CataloguePagination from "../Product/shared/Pagination";
import Skeleton from "../ReprintAuth/Skeleton";
import DemandFactorRow from "./Row";
import { TargetNames } from "./targetSummary";
import { DemandAdjustmentList } from "./useDemandAdjustmentList";

const COLUMNS = [
  "ชื่อ",
  "ประเภท",
  "ช่วงวันที่",
  "ตัวคูณ",
  "เป้าหมาย",
  "สถานะ",
  "ผู้แก้ล่าสุด",
  "การดำเนินการ",
];

/** Height of a loaded row with a one-line target list, so loading does not resize the table. */
const SKELETON_ROW_HEIGHT = 57;

const headSx = { bgcolor: (theme: Theme) => theme.palette.background.default };

const headCellSx = {
  borderRight: (theme: Theme) => `1px solid ${theme.palette.draft.main}`,
  "&:last-of-type": { borderRight: "none" },
  whiteSpace: "nowrap",
};

interface DemandFactorTableProps {
  list: DemandAdjustmentList;
  names: TargetNames;
  onEdit: (row: DemandAdjustment) => void;
  onDelete: (row: DemandAdjustment) => void;
}

export default function DemandFactorTable({
  list,
  names,
  onEdit,
  onDelete,
}: DemandFactorTableProps) {
  const { rows, count, loading, page, setPage, limit, setLimit } = list;

  return (
    <Paper sx={{ p: 0, overflow: "hidden" }}>
      <TableContainer>
        <Table>
          <TableHead sx={headSx}>
            <TableRow>
              {COLUMNS.map((column) => (
                <TableCell key={column} sx={headCellSx}>
                  {column}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {loading && (
              <Skeleton columns={COLUMNS.length} rows={limit} rowHeight={SKELETON_ROW_HEIGHT} />
            )}
            {!loading && rows.length === 0 && (
              <TableRow>
                <TableCell colSpan={COLUMNS.length} align="center" sx={{ py: 5 }}>
                  <Typography color="text.secondary" fontWeight={500}>
                    ไม่พบ Demand Factor ตามเงื่อนไข
                  </Typography>
                </TableCell>
              </TableRow>
            )}
            {!loading &&
              rows.map((row, index) => (
                <DemandFactorRow
                  key={row.id}
                  row={row}
                  striped={index % 2 === 1}
                  names={names}
                  onEdit={onEdit}
                  onDelete={onDelete}
                />
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <CataloguePagination
        totalCount={count}
        page={page}
        setPage={setPage}
        limit={limit}
        setLimit={setLimit}
      />
    </Paper>
  );
}
